import { MessageSquare, Camera, Ruler, MapPin } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { BUSINESS, IMAGES } from "../lib/site";

const STEPS = [
    { icon: Camera, text: "Snap a photo of the stump with something for scale — a boot or a tape measure works." },
    { icon: Ruler, text: "Rough width across the top in inches, if you know it." },
    { icon: MapPin, text: "Your address or nearest town so we can check the 30-mile radius." },
];

const PhotoTextLine = () => (
    <section className="border-y border-brand-line bg-brand-surface" data-testid="photo-text-section">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-24 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            <Reveal className="lg:col-span-7">
                <Eyebrow className="mb-4">Photo text line</Eyebrow>
                <h2 className="font-display font-black uppercase text-brand-cream text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[0.95] mb-6">
                    Text us a photo.
                    <br />
                    Get a <span className="text-brand-amber">real number.</span>
                </h2>
                <p className="text-brand-sage text-base sm:text-lg leading-relaxed max-w-xl mb-10">
                    Skip the back-and-forth. Send a picture of your stump straight
                    to our phone and we'll text back a price from the spec sheet —
                    usually the same day, during business hours.
                </p>
                <ul className="space-y-4 mb-10">
                    {STEPS.map(({ icon: Icon, text }, i) => (
                        <li key={text} className="flex items-start gap-4" data-testid={`photo-text-step-${i + 1}`}>
                            <span className="shrink-0 w-9 h-9 rounded-full border border-brand-amber/40 bg-brand-amber/10 flex items-center justify-center">
                                <Icon className="w-4 h-4 text-brand-amber" />
                            </span>
                            <span className="text-brand-sage text-sm sm:text-base leading-relaxed pt-1.5">{text}</span>
                        </li>
                    ))}
                </ul>
                <a
                    href={BUSINESS.phoneSms}
                    data-testid="photo-text-sms-cta"
                    className="group inline-flex items-center justify-center gap-3 bg-brand-amber text-brand-ink font-bold text-base sm:text-lg px-8 py-4 rounded-full hover:bg-brand-amberHover transition-all duration-300 hover:gap-4"
                >
                    <MessageSquare className="w-5 h-5" />
                    Text a photo to {BUSINESS.phoneDisplay}
                </a>
                <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.2em] text-brand-moss">
                    Opens your messaging app · Standard rates apply
                </p>
            </Reveal>

            <Reveal className="lg:col-span-5" delay={0.1}>
                <div className="relative rounded-lg overflow-hidden border border-brand-line clip-notch aspect-[4/5]">
                    <img
                        src={IMAGES.weatheredStump}
                        alt="Weathered tree stump in a yard, the kind customers photograph for a text quote"
                        className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-brand-ink via-brand-ink/20 to-transparent" />
                    <div className="absolute bottom-5 left-5 right-5 rounded-lg border border-brand-line bg-brand-ink/85 backdrop-blur p-4" data-testid="photo-text-sample-bubble">
                        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-brand-amber mb-2">
                            Sample reply
                        </p>
                        <p className="text-brand-cream text-sm leading-relaxed">
                            "Looks like a ~24" oak, open front yard. That's $220
                            flat with grindings raked back in. We can be out
                            Thursday — want me to lock it in?"
                        </p>
                    </div>
                </div>
            </Reveal>
        </div>
    </section>
);

export default PhotoTextLine;
